export const watchers = [
  {
    // Hybrid scaffolding - needed for the TKO mechanism
    getter: (state, { preferences }, getters) =>
      preferences.user.filterSidebarVisible && getters['responsive/useFiltersPopover'],
    callback: ({ dispatch }) =>
      dispatch('preferences/change', {
        scope: 'user',
        prefs: { filterSidebarVisible: false },
      }),
  },
];

export default {
  namespaced: true,
  // Avoid any kind of FOUC here by setting the default directly
  state: {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    visible: true,
  },
  getters: {
    useFiltersPopover: (state, getters, { routes }) => state.width < (routes.tkoCurrentRoute.hasSidebar ? 1275 : 1024),
  },
  mutations: {
    width: (state, width) => {
      state.width = width;
    },
    height: (state, height) => {
      state.height = height;
    },
    visible: (state) => {
      state.visible = true;
    },
    hidden: (state) => {
      state.visible = false;
    },
  },
  actions: {
    width: ({ commit }, width) => commit('width', width),
    height: ({ commit }, height) => commit('height', height),
    visible: ({ commit }) => commit('visible'),
    hidden: ({ commit }) => commit('hidden'),
  },
};
